import { doc, subCollection, Timestamp } from "@doitintl/models-types";

export const AUTO_GENERATED_AWS_ACCOUNTS_DOC_KEY = "auto-generated-aws-accounts";
export const AWS_ACCOUNTS_COLLECTION_KEY = "awsAccounts";
export const AWS_ACCOUNT_COMMANDS_COLLECTION_KEY = "awsAccountCommands";
export const TWILIO_PHONE_NUMBER_USAGE_HISTORY_COLLECTION_KEY = "twilioPhoneNumberUsageHistory";

export enum AwsAccountCompletionStep {
  CREDENTIALS = "CREDENTIALS",
  ACCOUNT_DATA = "ACCOUNT_DATA",
  PAYMENT_INFORMATION = "PAYMENT_INFORMATION",
  IDENTITY_CONFIRMATION = "IDENTITY_CONFIRMATION",
  ADMIN_ROLES = "ADMIN_ROLES",
  MFA = "MFA",
  GENUINE_AWS_ACCOUNT_ID = "GENUINE_AWS_ACCOUNT_ID",
  ACCOUNT_ALIAS = "ACCOUNT_ALIAS",
}

@subCollection(AWS_ACCOUNTS_COLLECTION_KEY)
export class AwsAccountModel {
  public static readonly FIREBASE_KEY = AWS_ACCOUNTS_COLLECTION_KEY;
  accountName!: string;
  genuineAwsAccountId!: string | null;
  email!: string;
  completeSteps!: AwsAccountCompletionStep[];
}

export enum AwsAccountCommandType {
  CREATE_AWS_ACCOUNT = "CREATE_AWS_ACCOUNT",
}

export enum AwsAccountCommandStatus {
  SCHEDULED = "SCHEDULED",
  AWAITING = "AWAITING",
  RUNNING = "RUNNING",
  FAILED = "FAILED",
  TERMINATED = "TERMINATED",
}

export type AwsAccountCommandCaptcha = {
  captchaImageURL: string;
  captchaSolution: string;
};

@subCollection(AWS_ACCOUNT_COMMANDS_COLLECTION_KEY)
export class AwsAccountCommand {
  public static readonly FIREBASE_KEY = AWS_ACCOUNT_COMMANDS_COLLECTION_KEY;
  accountId!: string;
  type!: AwsAccountCommandType;
  status!: AwsAccountCommandStatus;
  errorMessage!: string | null;
  captcha!: AwsAccountCommandCaptcha | null;
  timeCreated!: Timestamp;
  processingStartedAt!: Timestamp | null;
  retryCount!: number;
}

@doc(AUTO_GENERATED_AWS_ACCOUNTS_DOC_KEY)
export class AutoGeneratedAwsAccountsDoc {
  subCollections!: {
    [AWS_ACCOUNTS_COLLECTION_KEY]: AwsAccountModel;
    [AWS_ACCOUNT_COMMANDS_COLLECTION_KEY]: AwsAccountCommand;
    [TWILIO_PHONE_NUMBER_USAGE_HISTORY_COLLECTION_KEY]: TwilioPhoneNumberUsageHistory;
  };
}

export enum TwilioPhoneNumberUsageHistoryStatus {
  IN_USE = "IN_USE",
  FREE = "FREE",
}

@subCollection(TWILIO_PHONE_NUMBER_USAGE_HISTORY_COLLECTION_KEY)
export class TwilioPhoneNumberUsageHistory {
  public static readonly FIREBASE_KEY = TWILIO_PHONE_NUMBER_USAGE_HISTORY_COLLECTION_KEY;
  phoneNumber!: string;
  usedAt!: Timestamp;
  status!: TwilioPhoneNumberUsageHistoryStatus;
  awsAccountId!: string | null;
  phonePIN!: string | null;
}
